import { render, staticRenderFns } from "./AdminDashboardTopJurisdictionVisited.vue?vue&type=template&id=58fd4885&"
import script from "./AdminDashboardTopJurisdictionVisited.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardTopJurisdictionVisited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports